import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { InformacaoFechamentoMarcacaoConsultaDTO } from '../../../dtos/informacao-fechamento-marcacao-consulta-dto';
import { MarcacaoDTO } from '../../../dtos/marcacao-dto';
import { ResponseDTO } from '../../../dtos/response-dto';
import { Filial } from '../../../filial/filial';
import { FilialService } from '../../../filial/filial.service';
import { FechamentoMarcacao } from '../../../marcacao/fechamento-marcacao';
import { MarcacaoConsulta } from '../../../marcacao/marcacao-consulta/marcacao-consulta';
import { MarcacaoConsultaService } from '../../../marcacao/marcacao-consulta/marcacao-consulta.service';
import { MarcacaoConsultaPK } from '../../../marcacao/marcacao-consulta/pks/marcacao-consulta-pk';
import { Medico } from '../../../medico/medico';
import { MedicoService } from '../../../medico/medico.service';
import { IndTitularPipe } from '../../../pipes/ind-titular-pipe';
import { ServicosUtilidadesService } from '../../../servicos-utilidades/servicos-utilidades.service';
import { CustomDateValidator } from '../../../validators/custom-date-validator';

@Component({
  selector: 'app-atendimento-consulta-list',
  templateUrl: './atendimento-consulta-list.component.html',
  styleUrls: ['./atendimento-consulta-list.component.css']
})
export class AtendimentoConsultaListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['horaAtendimento', 'nomePaciente', 'indTitular', 'cpf', 'nomePlanoSaude', 'nomeProcedimentoConsulta', 'status', 'detalhe', 'acoes'];

  formularioDeAtendimentoConsulta: FormGroup;

  filtroMarcacao: MarcacaoDTO;

  listaFiliais: Filial[];

  usuarioLogado: ResponseDTO;

  ocultarOpcaoExcluir: boolean = true;

  totalMarcacoes: number = 0;

  totalMarcacoesAgendadas: number = 0;

  totalMarcacoesAtendidadas: number = 0;

  totalMarcacoesCanceladas: number = 0;

  totalFaltas: number = 0;

  dataAtual: Date | undefined;

  listaMedicos: Medico[] = [];

  constructor(private marcacaoConsultaService: MarcacaoConsultaService,
    private filialService: FilialService, private servicosUtilidadesService: ServicosUtilidadesService,
    router: Router, dialog: MatDialog, private formBuilder: FormBuilder,
    private indTitularPipe: IndTitularPipe, private medicoService: MedicoService) {

    super(router, dialog);

    this.filtroMarcacao = history.state.filtroMarcacao;

    this.listaFiliais = [];

    this.usuarioLogado = JSON.parse(localStorage.getItem('currentUser') || '{}');

    this.configurarVisibilidadeOpcaoDeExcluir();

    this.formularioDeAtendimentoConsulta = this.formBuilder.group({
      idFilial: ['', [Validators.required]],
      dataMarcacao: ['', [Validators.required]],
      idMedico: [''],
    }, {
      validator: CustomDateValidator('dataMarcacao')
    });
  }

  ngOnInit() {

    if (history.state.textFilter) {
      this.textFilter = history.state.textFilter;
      (<HTMLInputElement>document.getElementById("textFilter")).value = this.textFilter;
    }

    this.listarFiliais();

    if (!this.filtroMarcacao) {
      this.filtroMarcacao = new MarcacaoDTO();
    }

    if (!this.filtroMarcacao.dataMarcacao) {
      this.filtroMarcacao.dataMarcacao = new Date();
      this.formularioDeAtendimentoConsulta.controls.dataMarcacao.setValue(this.filtroMarcacao.dataMarcacao);
    }

    if (this.filtroMarcacao && this.filtroMarcacao.idFilial && this.filtroMarcacao.dataMarcacao) {

      this.formularioDeAtendimentoConsulta.patchValue(this.filtroMarcacao);

      this.reloadData(this.filtroMarcacao);
    }

    super.ngOnInit();

    this.listarMedicos();
  }

  reloadData(marcacaoDTO: MarcacaoDTO) {

    if (!marcacaoDTO.idFilial || !marcacaoDTO.dataMarcacao) {

      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Selecione todos os campos de filtro!'
        }
      });

    } else {

      this.marcacaoConsultaService.procurarMarcacaoConsultaPorFiltroComProjecao(marcacaoDTO)
        .subscribe(data => {
          // console.log(data)

          const listaMarcacoes: Array<MarcacaoDTO> = [];

          data.forEach((element: any) => {
            listaMarcacoes.push(Object.assign(new MarcacaoDTO(), element));
          });

          this.data = listaMarcacoes;

          this.configurarformatacoes(this.data);

          this.configurarDataSource();

          this.configurarTotalizadores();

          if (this.textFilter) {
            this.doFilterOnLoad();
          }
        }, error => {
          console.log(error);
        });
    }
  }
  configurarformatacoes
    (data: MarcacaoDTO[]) {

    data.forEach(
      (val, index) => {
        data[index].indTitular = this.indTitularPipe.transform(data[index].cpfTitular);
      });

    return data;
  }

  configurarTotalizadores(): void {

    if (this.dataAtual) {

      this.atualizarValores();

    } else {
      this.servicosUtilidadesService.getDataAtual().subscribe(data => {

        this.dataAtual = data;

        this.atualizarValores();

      }, error => {
        console.log(error);
      });
    }
  }

  atualizarValores(): void {

    this.totalMarcacoes = this.data.length;

    this.totalMarcacoesAgendadas = 0;

    this.totalMarcacoesAtendidadas = 0;

    this.totalMarcacoesCanceladas = 0;

    this.totalFaltas = 0;

    this.data.forEach((dto: MarcacaoDTO) => {

      if (dto.status === MarcacaoConsulta.STATUS_FINALIZADO) {
        this.totalMarcacoesAtendidadas++;
      } else if (dto.status === MarcacaoConsulta.STATUS_CANCELADO) {
        this.totalMarcacoesCanceladas++;
      } else {
        if (!this.dataAtual || !dto.dataMarcacao || dto.dataMarcacao >= this.dataAtual) {
          this.totalMarcacoesAgendadas++;
        } else {
          this.totalFaltas++;
        }
      }
    });
  }

  onSubmit() {
    this.filtroMarcacao = this.formularioDeAtendimentoConsulta.value;

    this.reloadData(this.filtroMarcacao);
  }

  confirmDelete(marcacaoDTO: MarcacaoDTO) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(marcacaoDTO);
      }
    });
  }

  delete(marcacaoDTO: MarcacaoDTO) {
    this.marcacaoConsultaService.removerMarcacao(marcacaoDTO.getPkConsultaDaEntidade())
      .subscribe(
        data => {
          // console.log(data);

          this.filtroMarcacao = this.formularioDeAtendimentoConsulta.value;

          this.reloadData(this.filtroMarcacao);
        },
        error => {
          console.log(error);
        });
  }

  details(marcacaoDTO: MarcacaoDTO) {

    const filtroAtual: MarcacaoDTO = this.formularioDeAtendimentoConsulta.value;

    this.router.navigate(['detalharMarcacaoConsulta'], {
      state: {
        marcacaoDTO: marcacaoDTO,
        filtroMarcacao: filtroAtual,
        paginaAnterior: 'atendimentoConsulta',
        textFilter: this.textFilter,
      }
    });
  }

  listarFiliais() {
    this.filialService.semRelacionamento()
      .subscribe(data => {
        // console.log(data)
        this.listaFiliais = data;

      }, error => {
        console.log(error);
      });
  }

  cancelar(marcacaoDTO: MarcacaoDTO) {

    if (!marcacaoDTO.motivoCancelamentoMarcacao) {
      this.router.navigate(['cancelarMarcacao'], {
        state: {
          filtroMarcacao: this.formularioDeAtendimentoConsulta.value,
          marcacaoDTO: marcacaoDTO,
          tipoMarcacao: 'TIPO_MARCACAO_CONSULTA',
          paginaAnterior: 'atendimentoConsulta',
          textFilter: this.textFilter,
        }
      });
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Marcação já cancelada!'
        }
      });
    }
  }

  executarAcaoDoStatusSelecionado(marcacaoDTO: MarcacaoDTO): void {

    if (marcacaoDTO) {

      if (marcacaoDTO.status === MarcacaoConsulta.STATUS_AGENDADO) {

        this.fecharMarcacao(marcacaoDTO);

      } else if (marcacaoDTO.status === MarcacaoConsulta.STATUS_CANCELADO) {

        this.irParaTelaDeCancelamento(marcacaoDTO);

      } else if (marcacaoDTO.status === MarcacaoConsulta.STATUS_FINALIZADO) {

        this.irParaTelaDeFechamento(marcacaoDTO);

      }
    }
  }

  fecharMarcacao(marcacaoDTO: MarcacaoDTO): void {

    if (this.usuarioLogado && this.usuarioLogado.username) {
      const fechamentoMarcacao: FechamentoMarcacao = new FechamentoMarcacao();
      fechamentoMarcacao.loginUserFechamento = this.usuarioLogado.username;

      const pk: MarcacaoConsultaPK = marcacaoDTO.getPkConsultaDaEntidade();

      const infoFechamento: InformacaoFechamentoMarcacaoConsultaDTO = new InformacaoFechamentoMarcacaoConsultaDTO();
      infoFechamento.pkMarcacao = pk;
      infoFechamento.fechamentoMarcacao = fechamentoMarcacao;

      this.marcacaoConsultaService.fecharMarcacao(infoFechamento)
        .subscribe(data => {
          // console.log(data)

          this.filtroMarcacao = this.formularioDeAtendimentoConsulta.value;

          this.reloadData(this.filtroMarcacao);

        }, error => {
          console.log(error);
        });

    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Não será possível fechar a Marcação. Usuário logado não encontrado!'
        }
      });
    }
  }

  irParaTelaDeFechamento(marcacaoDTO: MarcacaoDTO): void {
    this.router.navigate(['informacaoFechamento'], {
      state: {
        filtroMarcacao: this.formularioDeAtendimentoConsulta.value,
        fechamentoMarcacao: marcacaoDTO.fechamentoMarcacao,
        paginaAnterior: 'atendimentoConsulta',
        textFilter: this.textFilter,
      }
    });
  }

  irParaTelaDeCancelamento(marcacaoDTO: MarcacaoDTO): void {
    this.router.navigate(['informacaoCancelamento'], {
      state: {
        filtroMarcacao: this.formularioDeAtendimentoConsulta.value,
        motivoCancelamentoMarcacao: marcacaoDTO.motivoCancelamentoMarcacao,
        paginaAnterior: 'atendimentoConsulta',
        textFilter: this.textFilter,
      }
    });
  }

  configurarVisibilidadeOpcaoDeExcluir(): void {

    this.ocultarOpcaoExcluir = true;

    if ((this.usuarioLogado && this.usuarioLogado.perfil &&
      (this.usuarioLogado.perfil === 'ROLE_ADMIN' || this.usuarioLogado.perfil === 'ROLE_ROOT')
    ) ||
      this.usuarioLogado.username === 'thayna') {

      this.ocultarOpcaoExcluir = false;

    }
  }

  listarMedicos() {
    this.medicoService.listarComProjecao()
      .subscribe(data => {

        // console.log(data)
        this.listaMedicos = data;

      }, error => {
        console.log(error);
      });
  }

}
